export const CONTRACTS_QUERY_TOKEN = "contracts";
